module.exports = __webpack_public_path__ + "img/p2_section_step.5b5131c9.png";